// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__24w2O","label":"Section_label__1eYTH","contentWrap":"Section_contentWrap__2frUX","footer":"Section_footer__2k0Bc","footerInner":"Section_footerInner__dhCoY"};